/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Hover Drag Icon component.
 */
export const HoverDragIcon = ({color = dlsColor('grey1')}: IconProps) => {
  const {iconColor} = useIconDLS({color});
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='15' y='1' width='14' height='14' rx='4' transform='rotate(90 15 1)' fill={dlsColor('grey7')} />
      <path d='M10.333 10.333C10.9745 10.3332 11.499 10.8584 11.499 11.5C11.4988 12.1414 10.9744 12.6658 10.333 12.666C9.69145 12.666 9.16619 12.1415 9.16602 11.5C9.16602 10.8583 9.69134 10.333 10.333 10.333ZM10.333 6.83301C10.9745 6.83319 11.499 7.35844 11.499 8C11.4988 8.64141 10.9744 9.16584 10.333 9.16602C9.69145 9.16602 9.16619 8.64152 9.16602 8C9.16602 7.35833 9.69134 6.83301 10.333 6.83301ZM10.333 3.33301C10.9745 3.33319 11.499 3.85844 11.499 4.5C11.4988 5.14141 10.9744 5.66584 10.333 5.66602C9.69145 5.66602 9.16619 5.14152 9.16602 4.5C9.16602 3.85833 9.69134 3.33301 10.333 3.33301Z' fill={iconColor} />
      <path d='M6.24902 5.66699C5.6075 5.66681 5.08301 5.14156 5.08301 4.5C5.08318 3.85859 5.60761 3.33416 6.24902 3.33398C6.89058 3.33398 7.41584 3.85848 7.41601 4.5C7.41601 5.14167 6.89069 5.66699 6.24902 5.66699ZM6.24902 9.16699C5.6075 9.16681 5.08301 8.64156 5.08301 8C5.08318 7.35859 5.60761 6.83416 6.24902 6.83398C6.89058 6.83398 7.41584 7.35848 7.41601 8C7.41602 8.64167 6.89069 9.16699 6.24902 9.16699ZM6.24902 12.667C5.6075 12.6668 5.08301 12.1416 5.08301 11.5C5.08318 10.8586 5.60761 10.3342 6.24902 10.334C6.89058 10.334 7.41584 10.8585 7.41602 11.5C7.41602 12.1417 6.89069 12.667 6.24902 12.667Z' fill={iconColor} />
    </svg>
  );
};

export default HoverDragIcon;
